function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useCallback, useEffect, useReducer } from 'react';
import { buildInitialState } from './context';
export var dataViewReducer = function dataViewReducer(state, action) {
  switch (action.type) {
    case 'RESET':
      return action.data;
    case 'SET_DATA_SOURCE_LOADING':
      return setDataSourceLoading(state);
    case 'SET_DATA_SOURCE':
      return setDataSource(state, action.data);
    case 'SET_SELECTED_IDS':
      return setSelectedIds(state, action.data);
    case 'SET_FILTER_VALUE':
      return setFilterValue(state, action.data.key, action.data.value);
    case 'SET_REFRESH_TIMESTAMP_UPDATE_HANDLER':
      return setRefreshTimestampUpdateHandler(state, action.data);
    case 'SET_REFRESH_REQUESTED':
      return setRefreshRequested(state);
    case 'SET_AUTO_REFRESH_REQUESTED':
      return setRefreshRequested(state, true);
    case 'SET_TABLE_STATE':
      return setTableState(state, action.data);
    case 'SET_CURRENT_PAGE':
      return setCurrentPage(state, action.data);
    default:
      return state;
  }
};
export var useRequestDataSourceReloadDispatcher = function useRequestDataSourceReloadDispatcher(dispatch) {
  var dispatcher = useCallback(function () {
    dispatch({
      type: 'SET_REFRESH_REQUESTED'
    });
  }, []);
  return dispatcher;
};
export var useDataViewReducer = function useDataViewReducer(props) {
  var _props$levelResource2, _props$levelResource3;
  var _useReducer = useReducer(dataViewReducer, buildInitialState(props)),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    context = _useReducer2[0],
    dispatch = _useReducer2[1];
  var requestDataSourceReload = useRequestDataSourceReloadDispatcher(dispatch);
  useEffect(function () {
    var _props$levelResource;
    if (props.id !== context.id || ((_props$levelResource = props.levelResource) === null || _props$levelResource === void 0 ? void 0 : _props$levelResource.id) !== context.levelResource.id) {
      dispatch({
        type: 'RESET',
        data: buildInitialState(props)
      });
    }
  }, [props.id, (_props$levelResource2 = props.levelResource) === null || _props$levelResource2 === void 0 ? void 0 : _props$levelResource2.level, (_props$levelResource3 = props.levelResource) === null || _props$levelResource3 === void 0 ? void 0 : _props$levelResource3.id]);
  return [context, dispatch, requestDataSourceReload];
};

/**
 * Individual reducer functions should not be exported for testing.
 * Unit tests should use the dataViewReducer method + and associated
 * action type and data pack.
 */

function setDataSourceLoading(state) {
  var loading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return _objectSpread(_objectSpread({}, state), {}, {
    dataSourceLoading: loading,
    refreshing: state.refreshRequested || state.autoRefreshRequested
  });
}
function setDataSource(state, _ref) {
  var data = _ref.data,
    links = _ref.links;
  /**
   * New data source assigment should ensure the refresh timer
   * is updated to offset the next auto-run from now
   */
  state.refreshTimestampUpdateHandler();
  return setDataSourceLoading(_objectSpread(_objectSpread({}, state), {}, {
    dataSource: data,
    paginationLinks: links,
    /**
     * New data source assigment should resolve any open refresh requests
     */
    refreshRequested: false,
    autoRefreshRequested: false
  }), false);
}
function setSelectedIds(state, ids) {
  return _objectSpread(_objectSpread({}, state), {}, {
    selectedIds: ids
  });
}
function setFilterValue(state, key, value) {
  var filterValues = _objectSpread({}, state.filterValues);
  if (value === undefined) {
    delete filterValues[key];
  } else {
    filterValues[key] = value;
  }
  return setCurrentPage(_objectSpread(_objectSpread({}, state), {}, {
    filterValues: filterValues
  }), 1);
}
function setRefreshTimestampUpdateHandler(state, handler) {
  return _objectSpread(_objectSpread({}, state), {}, {
    refreshTimestampUpdateHandler: handler
  });
}
function setRefreshRequested(state) {
  var isAutoRequest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var update = _objectSpread({}, state);
  if (!state.refreshing) {
    if (isAutoRequest && !state.refreshRequested) {
      update.autoRefreshRequested = true;
    } else if (!isAutoRequest && !state.autoRefreshRequested) {
      update.refreshRequested = true;
    }
  }
  return update;
}
function setTableState(state, data) {
  return _objectSpread(_objectSpread({}, state), {}, {
    table: data
  });
}
function setCurrentPage(state, page) {
  return setTableState(state, _objectSpread(_objectSpread({}, state.table), {}, {
    pagination: _objectSpread(_objectSpread({}, state.table.pagination), {}, {
      current: page
    })
  }));
}